var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"livechat"},[_c('livechat-mw',{staticClass:"livechat__main-window"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }